module.exports = __webpack_public_path__ + "static/img/user-logo-004.47c014e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user-logo-004.png
// module id = NzWZ
// module chunks = 1